/// <amd-module name="TFS/Views/ProjectOverviewPage/Stores/StoresHub" />
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/Actions/ActionsHub";
import { CurrentUserInfoStore } from "TFS/Views/ProjectOverviewPage/Shared/CurrentUserInfoStore";
import { ProjectOverviewPageData } from "TFS/Views/ProjectOverviewPage/Shared/Models";
import { ProjectBasicInfoStore } from "TFS/Views/ProjectOverviewPage/Shared/ProjectBasicInfoStore";
import { ProjectMembersStore } from "TFS/Views/ProjectOverviewPage/Shared/ProjectMembersStore";
/**
 * A container to hold the multiple stores of project overview page
 */
export class StoresHub {
    public projectBasicInfoStore: ProjectBasicInfoStore;
    public currentUserInfoStore: CurrentUserInfoStore;
    public projectMembersStore: ProjectMembersStore;

    constructor(actionsHub: ActionsHub) {
        this.projectBasicInfoStore = new ProjectBasicInfoStore("projectBasicInfoStoreChangedEvent");
        actionsHub.projectOverviewPageLoaded.addListener(this._loadProjectInfo);
        actionsHub.projectOverviewPageLoadFailed.addListener(this.projectBasicInfoStore.loadProjectInfoFailed);

        this.currentUserInfoStore = new CurrentUserInfoStore("currentUserInfoStoreChangedEvent");
        actionsHub.projectOverviewPageLoaded.addListener(this._loadCurrentUserInfo);
        actionsHub.projectOverviewPageLoadFailed.addListener(this.currentUserInfoStore.loadCurrentUserInfoFailed);

        this.projectMembersStore = new ProjectMembersStore("projectMembersStoreChangedEvent");
        actionsHub.projectMembersFetched.addListener(this.projectMembersStore.loadMembersInfo);
        actionsHub.projectMembersFetchFailed.addListener(this.projectMembersStore.loadMembersInfoFailed);
    }

    private _loadProjectInfo = (projectOverviewPageData: ProjectOverviewPageData): void => {
        this.projectBasicInfoStore.loadProjectInfo(projectOverviewPageData.projectBasicData);
    };

    private _loadCurrentUserInfo = (projectOverviewPageData: ProjectOverviewPageData): void => {
        this.currentUserInfoStore.loadCurrentUserInfo(projectOverviewPageData.currentUser);
    };
}
